import * as pxp from 'lib/pxp'

/**
 * Temporary treatment to ramp up a fix which resolves a typo in the DDC flow.
 *
 * https://internal.msmaster.qa.paypal.com/elmo/experiment/132129
 *
 * related: https://www.msmaster.qa.paypal.com/elmo/experiment/102152
 * context: https://paypal.atlassian.net/browse/DTPPTECH-788
 */
export function isDataCollectionEnabled() {
  return pxp.isTreatment('Trmt_three_ds_ddc_p2p_T1')
}
